module.exports = __webpack_public_path__ + "static/img/17.67f57187.png";